import { DateTime } from "luxon";

export const colors = {
  Offline: "var(--teleforce-725)",
  "Not Ready": "var(--teleforce-725)",
  Ready: "#32bf38",
  Talking: "#0095ff",
  "Wrap-Up": "#d818f9",
  "Break 15": "var(--teleforce-725)",
  "Break 30": "var(--teleforce-725)",
  "Break 45": "var(--teleforce-725)",
  "Break 60": "var(--teleforce-725)",
  Restroom: "var(--teleforce-725)",
  Meeting: "var(--teleforce-725)",
  Observing: "var(--teleforce-725)"
};

export const formatPhoneNumber = number => {
  return number.replace(/(\d{3})(\d{3})(\d{4})/, "+1 ($1) $2-$3");
};

export const sortGrades = (a, b) => {
  if (a === "N/A") return 1;
  if (b === "N/A") return -1;
  const order = { "+": -1, "-": 1, undefined: 0 };
  if (!a || !b) {
    return null;
  }
  return a[0].localeCompare(b[0]) || order[a[1]] - order[b[1]];
};

export const sortShifts = (a, b) =>
  (a === "N/A") - (b === "N/A") || +(a > b) || -(a < b);

export const sortLocations = (a, b) => (a === "N/A") - (b === "N/A") || b - a;
export const sortTeams = (a, b) => (a === "N/A") - (b === "N/A") || a - b;

export function sortSchedules(a, b) {
  // If either schedule is "N/A", put it last
  if (a === "N/A") return 1;
  if (b === "N/A") return -1;

  const [startA, endA] = a.split("-");
  const [startB, endB] = b.split("-");

  const startTimeA = timeToMinutes(startA);
  const startTimeB = timeToMinutes(startB);

  // If start times are equal, compare end times
  if (startTimeA === startTimeB) {
    const endTimeA = timeToMinutes(endA);
    const endTimeB = timeToMinutes(endB);
    return endTimeA - endTimeB;
  }

  return startTimeA - startTimeB;
}

function timeToMinutes(timeStr) {
  const isPM = timeStr.includes("PM");
  let [hours, minutes] = timeStr.replace("AM", "").replace("PM", "").split(":");

  hours = parseInt(hours);
  minutes = minutes ? parseInt(minutes) : 0;

  // Convert to 24-hour format
  if (isPM && hours !== 12) hours += 12;
  if (!isPM && hours === 12) hours = 0;

  return hours * 60 + minutes;
}

export const sortFromTime = (a, b) => {
  if (a === null) {
    return -1;
  } else {
    if (b === null) {
      return 1;
    } else {
      const da = DateTime.fromFormat(a, "hh:mm:ss a");
      const db = DateTime.fromFormat(b, "hh:mm:ss a");
      return da - db;
    }
  }
};

export const sortQueuesByName = obj => {
  // Convert the object into an array of entries
  const entries = Object.entries(obj);

  // Sort the entries based on queue_name, with "Department" always last
  entries.sort((a, b) => {
    const nameA = a[1].queue_name.toUpperCase();
    const nameB = b[1].queue_name.toUpperCase();

    if (nameA === "DEPARTMENT") {
      return 1;
    }

    if (nameB === "DEPARTMENT") {
      return -1;
    }

    // Sort all other items alphabetically
    return nameA.localeCompare(nameB);
  });

  // Convert the sorted array back into an object
  const sortedObj = Object.fromEntries(entries);

  return sortedObj;
};

export const sortQueuesGroups = (a, b) => {
  return (
    (a === null) - (b === null) ||
    (a === "Department") - (b === "Department") ||
    +(a > b) ||
    -(a < b)
  );
};
